export interface ISalesRepresentative {
    ID: number;
    FirstName: string;
    LastName: string;
    Phone: string;
    Email: string;
}

export class SalesRepresentative implements ISalesRepresentative {
    ID: number;
    FirstName: string;
    LastName: string;
    Phone: string;
    Email: string;
}

export class SalesRepresentativeArray extends Array<SalesRepresentative> {

    constructor(...items: SalesRepresentative[]) {
        super(...items);
        Object.setPrototypeOf(this, SalesRepresentativeArray.prototype);
    }
}
